import React, { useState, useContext, useEffect } from "react";
import { Button, Box, TableBody, TableHead, TablePagination, makeStyles, InputAdornment, SvgIcon, Checkbox, Grid } from "@material-ui/core";
import { Search as SearchIcon } from "react-feather";
import { useForm } from "react-hook-form";
import { doctorServices, productsServices } from "../services";
import { AuthContext } from "../context";
import { Toast, ModalBase, TextField, StyledTableCell, StyledTableRow, BaseTable } from "./";

export default function AssignProductDoctor(props) {
	const classes = useStyles();
	const { authState } = useContext(AuthContext);
	const [limit, setLimit] = useState(10);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(0);
	const [laboratoryId] = useState(authState.user.laboratory._id);
	const [selectedDoctorsIds, setSelectedDoctorsIds] = useState([]);
	const [doctors, setDoctors] = useState([]);
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const { register, handleSubmit, errors } = useForm();

	useEffect(() => {
		async function getDoctors() {
			try {
				const { status, response } = await doctorServices.getDoctors({ page, limit, token: authState.token });
				if (status === 200) {
					setDoctors(response.doctors);
					setLimit(response.limit);
					setCount(response.total);
					setPage(response.page);
				}
			} catch (e) {
				console.log(e);
			}
		}
		getDoctors();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, limit, authState]);

	const getDoctorsFilter = async (text) => {
		try {
			const { status, response } = await doctorServices.getDoctorsFilter({ text, page, limit, token: authState.token });
			if (status === 200) {
				setDoctors(response.doctors);
				setLimit(response.limit);
				setCount(response.total);
				setPage(response.page);
			}
		} catch (e) {
			console.log(e);
		}
	};

	const handleSelectOne = (event, id) => {
		const selectedIndex = selectedDoctorsIds.indexOf(id);
		let newSelectedDoctorsIds = [];

		if (selectedIndex === -1) {
			newSelectedDoctorsIds = newSelectedDoctorsIds.concat(selectedDoctorsIds, id);
		} else if (selectedIndex === 0) {
			newSelectedDoctorsIds = newSelectedDoctorsIds.concat(selectedDoctorsIds.slice(1));
		} else if (selectedIndex === selectedDoctorsIds.length - 1) {
			newSelectedDoctorsIds = newSelectedDoctorsIds.concat(selectedDoctorsIds.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelectedDoctorsIds = newSelectedDoctorsIds.concat(
				selectedDoctorsIds.slice(0, selectedIndex),
				selectedDoctorsIds.slice(selectedIndex + 1)
			);
		}

		setSelectedDoctorsIds(newSelectedDoctorsIds);
	};

	const assignProduct = async (product) => {
		if (selectedDoctorsIds.length === 0) {
			setToast(true);
			setToastMessage("Seleccione al menos un doctor para asignar producto..");
		} else {
			let doctorsIds = [];
			selectedDoctorsIds.forEach((id) => {
				doctorsIds.push({
					_id: id,
				});
			});
			let payload = {
				laboratoryId: laboratoryId,
				productId: props.productId,
				assigned: product.quantity,
				doctors: doctorsIds,
			};
			try {
				const { status, response } = await productsServices.assignProdutc({ payload, token: authState.token });
				switch (status) {
					case 200:
						props.toast(response.message, true);
						props.close();
						props.reload();
						break;
					default:
						break;
				}
				if (response.error) {
					props.toast(response.error.message, true);
				}
			} catch (e) {
				console.log(e);
			}
		}
	};

	return (
		<ModalBase categoryModal open={props.open} close={props.close} title="Seleccionar médicos">
			<Toast
				message={toastMessage}
				open={toast}
				close={() => {
					setToast(false);
				}}
			/>
			<form className={classes.form} onSubmit={handleSubmit(assignProduct)}>
				<Box mt={3}>
					<Grid container spacing={2} alignItems="center" justify="center">
						<Grid item xs={12} sm={4}>
							<TextField
								onChange={(e) => {
									if (e.target.value.length === 0) {
										getDoctorsFilter("");
									} else {
										getDoctorsFilter(e.target.value);
									}
								}}
								fullWidth
								name="text"
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Button type="submit">
												<SvgIcon fontSize="small" color="action">
													<SearchIcon />
												</SvgIcon>
											</Button>
										</InputAdornment>
									),
								}}
								placeholder="Buscar"
								variant="outlined"
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<TextField
								defaultValue={1}
								required
								InputProps={{ inputProps: { min: 1 } }}
								type="number"
								label="Cantidad de producto"
								variant="outlined"
								name="quantity"
								id="quantity"
								error={errors.quantity ? true : false}
								inputRef={register({ required: "Cantidad requerida" })}
								helperText={errors.quantity ? errors.quantity.message : ""}
							/>
						</Grid>
						<Grid item sm={2} xs={12}>
							<Button fullWidth size="small" variant="contained" color="secondary" className={classes.button} type="submit">
								Asignar
							</Button>
						</Grid>
						<Grid item sm={2} xs={12}>
							<Button
								fullWidth
								size="small"
								variant="contained"
								color="primary"
								onClick={props.close}
								className={`${classes.button} ${classes.cancel}`}
							>
								Cancelar
							</Button>
						</Grid>
					</Grid>
					<BaseTable>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell>Rut</StyledTableCell>
								<StyledTableCell>Nombre</StyledTableCell>
								<StyledTableCell>Apellido</StyledTableCell>
								<StyledTableCell>Sexo</StyledTableCell>
								<StyledTableCell>Fecha de nacimiento</StyledTableCell>
								<StyledTableCell>Teléfono</StyledTableCell>
								<StyledTableCell>Teléfono de actividad</StyledTableCell>
								{/* <StyledTableCell>Correo</StyledTableCell> */}
								<StyledTableCell>Especialidad 1</StyledTableCell>
								<StyledTableCell>Especialidad 2</StyledTableCell>
								<StyledTableCell>Especialidad 3</StyledTableCell>
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{doctors.map((doctor, index) => (
								<StyledTableRow key={doctor._id}>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										<Checkbox
											checked={selectedDoctorsIds.indexOf(doctor._id) !== -1}
											onChange={(event) => handleSelectOne(event, doctor._id)}
											value="true"
										/>
									</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.rut}</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.name}</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.lastName}</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.gender}</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.birthdate !== "Invalid date" ? doctor.birthdate : "N/A"}
									</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.phone ? doctor.phone : "N/A"}
									</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.activityPhone ? doctor.activityPhone : "N/A"}
									</StyledTableCell>
									{/* <StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.email ? doctor.email : "N/A"}
									</StyledTableCell> */}
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{doctor.specialties[0].name}</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.specialties[1] ? doctor.specialties[1].name : "N/A"}
									</StyledTableCell>
									<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
										{doctor.specialties[2] ? doctor.specialties[2].name : "N/A"}
									</StyledTableCell>
								</StyledTableRow>
							))}
						</TableBody>
					</BaseTable>
					<TablePagination
						labelRowsPerPage="Registros por página"
						component="div"
						count={count}
						onChangeRowsPerPage={(e) => setLimit(e.target.value)}
						onChangePage={(e, page) => setPage(page + 1)}
						page={page - 1}
						rowsPerPage={limit}
						rowsPerPageOptions={[10, 25, 50, 100]}
					/>
				</Box>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	button: {
		height: 45,
		borderRadius: 25,
		boxShadow: "unset",
		textTransform: "uppercase",
		fontWeight: "bold",
		"&:hover": {
			boxShadow: "unset",
		},
	},
	cancel: {
		backgroundColor: "transparent",
		color: theme.palette.secondary.main,
		border: "3pt solid" + theme.palette.secondary.main,
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: "#f44336",
	},
	dialogTitle: {
		marginTop: "20px",
		textAlign: "Center",
	},
	container: {
		maxHeight: "100%",
		borderRadius: "22px 22px 22px 22px",
	},
}));
